/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { useState, useEffect } from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import {
  Button,
  Combobox,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Input,
} from "@repo/ui";
// eslint-disable-next-line import/no-cycle
import { showToast } from "utils/helper";
import {
  useGetCashCenters,
  useGetRegions,
  useGetOffices,
} from "utils/apis/lookups.api";
import { useEditRoute } from "utils/apis/rotes.api";

const currentDate = new Date();

const jobPriorities = [
  {
    value: "1",
    label: "High",
  },
  {
    value: "2",
    label: "Normal",
  },
  {
    value: "3",
    label: "Low",
  },
];

const routeStatusList = [
  {
    id: "Active",
    text: "Active",
  },
  {
    id: "Closed",
    text: "Closed",
  },
];

function EditRoute({ route, onRouteUpdated }: any) {
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [btnSaveText, setBtnSaveText] = useState("Save");

  const [routeData, setRouteData] = useState({
    routeId: route.routeId,
    cashCenter: route.cashCenter,
    cashCenterId: route.cashCenterId,
    office: route.office,
    officeId: route.officeId,
    routeNo: route.routeNo,
    description: route.description,
    routeArea: route.routeArea,
    priority: route?.priority?.toString(),
    requiredTeamMembers: route.requiredTeamMembers,
    teamNationalityCount: route.teamNationalityCount,
    routeStartTime: route.routeStartTime
      ? new Date(route.routeStartTime)
      : currentDate,
    routeEndTime: route.routeEndTime
      ? new Date(route.routeEndTime)
      : currentDate,
    status: route.status,
  });

  const [error, setError] = useState<any>({
    cashCenter: "",
    office: "",
    routeNo: "",
    description: "",
    routeArea: "",
    priority: "",
    requiredTeamMembers: 0,
    teamNationalityCount: 0,
    routeStartTime: null,
    routeEndTime: null,
    status: "",
  });
  const { data: cashCenters } = useGetCashCenters();
  const { data: cities } = useGetRegions("UAE");
  const { mutate: getOffices, data: offices } = useGetOffices();
  const {
    mutate: editRoute,
    isSuccess: editSuccess,
    isError: editError,
  } = useEditRoute();

  const onCashCentersChanged = (value: string) => {
    setRouteData({ ...routeData, cashCenterId: value, officeId: "" });
    if (!value) return;
    getOffices(value);
  };
  useEffect(() => {
    getOffices(route.cashCenterId);
  }, []);

  const onBtnUpdateRouteClicked = () => {
    let errorCount = 0;
    const errorObj: any = {
      cashCenterId: "",
      routeNo: "",
      description: "",
      routeArea: "",
      priority: "",
      officeId: "",
      requiredTeamMembers: 0,
      teamNationalityCount: 0,
      routeStartTime: null,
      routeEndTime: null,
      status: "",
    };

    if (!routeData.cashCenterId) {
      errorCount++;
      errorObj.cashCenterId = "indianred";
    }

    if (!routeData.officeId) {
      errorCount++;
      errorObj.officeId = "indianred";
    }

    if (routeData.routeNo === "") {
      errorCount++;
      errorObj.routeNo = "indianred";
    }

    if (routeData.description === "") {
      errorCount++;
      errorObj.description = "indianred";
    }

    if (!routeData.routeArea) {
      errorCount++;
      errorObj.routeArea = "indianred";
    }

    if (routeData.priority === "") {
      errorCount++;
      errorObj.priority = "indianred";
    }

    if (routeData.requiredTeamMembers === 0) {
      errorCount++;
      errorObj.requiredTeamMembers = "indianred";
    }

    if (routeData.teamNationalityCount === 0) {
      errorCount++;
      errorObj.teamNationalityCount = "indianred";
    }

    if (routeData.routeStartTime === null) {
      errorCount++;
      errorObj.routeStartTime = "indianred";
    }

    if (routeData.routeEndTime === null) {
      errorCount++;
      errorObj.routeEndTime = "indianred";
    }

    if (!routeData.status || !routeData.status) {
      errorCount++;
      errorObj.status = "indianred";
    }

    if (errorCount) {
      showToast("error", "Fields are required");
      setError(errorObj);
      return;
    }
    setError(errorObj);
    const obj = {
      routeId: routeData.routeId,
      cashCenterId: routeData.cashCenterId,
      officeId: routeData.officeId,
      routeNo: routeData.routeNo,
      description: routeData.description,
      routeArea: routeData.routeArea,
      priority: parseInt(routeData.priority),
      requiredTeamMembers: routeData.requiredTeamMembers,
      teamNationalityCount: routeData.teamNationalityCount,
      routeStartTime: routeData.routeStartTime,
      routeEndTime: routeData.routeEndTime,
      status: routeData.status,
    };

    setBtnDisabled(true);
    setBtnSaveText("Updating Route....");
    editRoute(obj);
  };

  useEffect(() => {
    if (editSuccess) {
      setBtnDisabled(false);
      setBtnSaveText("Save");
      setRouteData({
        routeId: route.routeId,
        cashCenter: route.cashCenter,
        cashCenterId: route.cashCenterId,
        office: route.office,
        officeId: route.officeId,
        routeNo: route.routeNo,
        description: route.description,
        routeArea: route.routeArea,
        priority: route.priority,
        requiredTeamMembers: route.requiredTeamMembers,
        teamNationalityCount: route.teamNationalityCount,
        routeStartTime: route.routeStartTime
          ? new Date(route.routeStartTime)
          : currentDate,
        routeEndTime: route.routeEndTime
          ? new Date(route.routeEndTime)
          : currentDate,
        status: { id: route.status, text: route.status },
      });
      onRouteUpdated(true);
    }

    if (editError) {
      setBtnDisabled(false);
      setBtnSaveText("Save");
    }
  }, [editSuccess, editError]);

  return (
    <>
      <div className="flex gap-4 mb-3">
        <div className="flex-1">
          <label className={`text-[${error.cashCenter}]`}>
            Cash Center<sup className="text-red-500">*</sup>
          </label>
          <Combobox
            data={cashCenters?.map((m) => ({
              value: m.cashCenterId,
              label: m.name,
            }))}
            value={routeData.cashCenterId}
            setValue={onCashCentersChanged}
            placeholder="Select Cash center"
          />
        </div>

        <div className="flex-1">
          <label>Office</label>
          <Combobox
            data={offices?.map((m: any) => ({
              value: m.officeId,
              label: m.officeName,
            }))}
            placeholder="Select Office"
            value={routeData.officeId}
            setValue={(e: string) => {
              setRouteData({ ...routeData, officeId: e });
            }}
          />
        </div>
      </div>

      <div className="flex gap-4 mb-3">
        <div className="flex-1">
          <label className={`text-{${error.routeNo}}`}>
            Route No
            <sup className="text-red-500">*</sup>
          </label>
          <Input
            placeholder="Route No"
            value={routeData.routeNo}
            onChange={(e) => {
              setRouteData({ ...routeData, routeNo: e.target.value });
            }}
          />
        </div>

        <div className="flex-1">
          <label className={`text-{${error.description}}`}>
            Description
            <sup className="text-red-500">*</sup>
          </label>
          <Input
            placeholder="Route Description"
            value={routeData.description}
            onChange={(e) => {
              setRouteData({ ...routeData, description: e.target.value });
            }}
          />
        </div>

        <div className="flex-1">
          <label className={`text-{${error.routeArea}}`}>
            Route Area
            <sup className="text-red-500">*</sup>
          </label>
          <Combobox
            data={cities?.map((m: any) => ({
              label: m.name,
              value: m.name,
            }))}
            value={routeData.routeArea}
            setValue={(e: string) => {
              setRouteData({ ...routeData, routeArea: e });
            }}
            placeholder="Select Route Area"
          />
        </div>
      </div>

      <div className="flex gap-4 mb-3">
        <div className="flex-1">
          <label className={`text-{${error.priority}}`}>
            Priority
            <sup className="text-red-500">*</sup>
          </label>
          <Select
            onValueChange={(e) => {
              setRouteData({ ...routeData, priority: e });
            }}
            value={routeData.priority}
          >
            <SelectTrigger>
              <SelectValue placeholder="Route Priority" />
            </SelectTrigger>
            <SelectContent>
              {jobPriorities?.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="flex-1">
          <label className={`text-{${error.requiredTeamMembers}}`}>
            Required Team Members Count
            <sup className="text-red-500">*</sup>
          </label>
          <NumericTextBox
            min={3}
            className="h-10"
            placeholder="Required Team Members Count"
            value={routeData.requiredTeamMembers}
            onChange={(e) => {
              setRouteData({
                ...routeData,
                requiredTeamMembers: e.target.value as number,
              });
            }}
          />
        </div>

        <div className="flex-1">
          <label className={`text-{${error.teamNationalityCount}}`}>
            Required Nationalities
            <sup className="text-red-500">*</sup>
          </label>
          <NumericTextBox
            min={1}
            className="h-10"
            placeholder="Max. Same Nationals Count"
            value={routeData.teamNationalityCount}
            onChange={(e) => {
              setRouteData({
                ...routeData,
                teamNationalityCount: e.target.value as number,
              });
            }}
          />
        </div>
      </div>

      <div className="flex gap-4">
        {/* <div className="flex-1">
          <label className={`text-{${error.routeStartTime}}`}>
            Route Start Time
            <sup className="text-red-500">*</sup>
          </label>
          <TimePicker
            placeholder="Route Start Time"
            className="h-10"
            value={routeData.routeStartTime}
            onChange={(e) => {
              setRouteData({ ...routeData, routeStartTime: e.value as Date });
            }}
          />
        </div>

        <div className="flex-1">
          <label className={`text-{${error.routeEndTime}}`}>
            Route End Time
            <sup className="text-red-500">*</sup>
          </label>
          <TimePicker
            className="h-10"
            placeholder="Route Start Time"
            value={routeData.routeEndTime}
            onChange={(e) => {
              setRouteData({ ...routeData, routeEndTime: e.value as Date });
            }}
          />
        </div> */}
        <div className="w-[32%]">
          <label className={`text-{${error.status}}`}>
            Route Status
            <sup className="text-red-500">*</sup>
          </label>
          <Select
            onValueChange={(e) => {
              setRouteData({ ...routeData, status: e });
            }}
            value={routeData.status}
          >
            <SelectTrigger>
              <SelectValue placeholder="Route Priority" />
            </SelectTrigger>
            <SelectContent>
              {routeStatusList.map((item) => (
                <SelectItem key={item.id} value={item.id}>
                  {item.text}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
      <div className="border-b my-3 bg-accent" />
      <Button
        variant="secondary"
        onClick={onBtnUpdateRouteClicked}
        disabled={btnDisabled}
        className="ml-auto flex w-[140px]"
      >
        {btnSaveText}
      </Button>
    </>
  );
}

export default EditRoute;
